import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, TouchableOpacity, Platform } from 'react-native';
import { Input, Button, IntakeFormQuestion, Line, Colors, Icon, Text, Checkbox } from '../components';
import { Picker } from '@react-native-picker/picker';
import { StringUtils } from '../utils';
import LottieView      from 'lottie-react-native';
import { config }      from '../../config';
import AsyncStorage    from '@react-native-async-storage/async-storage';
import AuthController  from '../controllers/authController';
import UserController  from '../controllers/userController';

class ConsultationStartPayment extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected_option: 'monthly', // 'monthly' 'six_months' 'single_payment'
      selected_price_id: config.subscription_amount_month_price_id || '',
      has_active_sub: false,
      loading_circle_animation: false,
      cat_eyes_animation: false,
      cat_orange_animation: false,
      check_success_animation: false,
      confetti_animation: false,
      price_data: {},
      previous_display_section: ''
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.animation_timer);
  }

  retrieve_sub_pricing_data = async () => {

    if (this.props.payment_status_action) {
      this.props.payment_status_action();
    }

    let price_response  = await AuthController.getSubscription({ partner_name: config.SELECTED_PARTNER });
    let price_data_obj  = price_response && price_response.success && price_response.subscription ? price_response.subscription : null;
    let price_data      = this.construct_price_data(null);
        price_data      = price_data_obj ? this.construct_price_data(price_data_obj) : price_data;

    this.setState({ price_data: price_data, selected_price_id: price_data.one_month_price_id });
  }

  componentDidMount = async () => {
    let animation_timer = setInterval(this._onEverySecond, 200);
    this.retrieve_sub_pricing_data();
    this.setState({ animation_timer: animation_timer });
    // this.setState({ animation_timer: animation_timer }, async () => {
    //   setTimeout(this.retrieve_sub_pricing_data, 2500);
    // });
  }

  _onEverySecond = async () => {
    let display_changed = this.state.previous_display_section !== this.props.display_section;
    if (display_changed) {
      this.setState({
        previous_display_section: this.props.display_section,
        loading_circle_animation: false,
        cat_eyes_animation: false,
        cat_orange_animation: false,
        check_success_animation: false,
        confetti_animation: false
      })
    }
    if (this.loading_circle_animation && !this.state.loading_circle_animation) {
      this.loading_circle_animation.play();
      this.setState({ loading_circle_animation: true });
    }
    if (this.cat_eyes_animation && !this.state.cat_eyes_animation) {
      this.cat_eyes_animation.play();
      this.setState({ cat_eyes_animation: true });
    }
    if (this.cat_orange_animation && !this.state.cat_orange_animation) {
      this.cat_orange_animation.play();
      this.setState({ cat_orange_animation: true });
    }
    if (this.check_success_animation && !this.state.check_success_animation) {
      this.check_success_animation.play();
      this.setState({ check_success_animation: true });
    }
    if (this.confetti_animation && !this.state.confetti_animation) {
      this.confetti_animation.play();
      this.setState({ confetti_animation: true });
    }
  }

  render_payment_option = (option) => {
    if (this.props.display_section !== 'prices') {
      return null;
    }

    let is_selected      = this.state.selected_option === option;
    let is_monthly       = option === 'monthly';
    let pricing_details  = this.get_pricing_details(option);

    return <TouchableOpacity style={{ borderWidth: 3, borderColor: is_selected ? Colors.PRIMARY : '#dddddd', borderStyle: 'solid', borderRadius: 20, marginTop: 4, marginBottom: 4 }}
                             onPress={ () => {
                               this.setState({ selected_option: option, selected_price_id: pricing_details.price_id });
                             }}>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <View style={{ paddingTop: 10, paddingLeft: 15 }}>
          <Text style={{ fontWeight: '500', fontSize: 17 }}>{ pricing_details.duration_string }</Text>
          <Text style={{ fontSize: 18, marginTop: 5, color: Colors.PRIMARY }}>{ pricing_details.price_string    }</Text>
        </View>
        <View style={{ paddingRight: 15, flexDirection: 'row' }}>
          { is_monthly   ? <View style={{ marginTop: 12, backgroundColor: 'orange', padding: 15, paddingLeft: 10, paddingRight: 10, paddingTop: 8, paddingBottom: 8, marginRight: 8, height: 33, borderRadius: 10 }}>
                             <Text style={{ fontWeight: '500', color: 'white', fontSize: 11 }}>MOST POPULAR</Text>
                           </View>
                         : null }
          { is_selected  ? <Icon name='check-circle' style={{ marginTop: 15 }} solid={true}  /> : null }
          { !is_selected ? <Icon name='circle'       style={{ marginTop: 15 }} solid={false} color='#dddddd' /> : null }
        </View>
      </View>
      <View style={{ paddingLeft: 15, marginTop: 10, marginBottom: 10 }}>
        <Text style={{ fontSize: 15, marginBottom: 5, color: 'grey' }}>{ pricing_details.feature_1_str }</Text>
        <Text style={{ fontSize: 15, marginBottom: 5, color: 'grey' }}>{ pricing_details.feature_2_str }</Text>
        <Text style={{ fontSize: 15, marginBottom: 5, color: 'grey' }}>{ pricing_details.feature_3_str }</Text>
      </View>
    </TouchableOpacity>
  }

  render_payment_options = () => {
    if (this.props.display_section !== 'prices') {
      return null;
    }

    return <View style={{ marginBottom: 20 }}>
      { this.render_payment_option('single_payment') }
      { this.render_payment_option('monthly')        }
      { this.render_payment_option('six_months')     }
    </View>
  }

  render_continue_button = () => {
    if (this.props.display_section === 'processing_payment' || this.props.display_section === 'loading_details') {
      return null;
    }

    return <View style={{ }}>
      { this.render_error_message() }
      <Button title={ 'Continue' }
              loading={this.props.loading}
              onPress={ async () => {
                let selected_option = this.state.selected_option;
                let price_id        = this.state.selected_price_id;

                if (this.props.loading) {
                  return;
                }
                if ((this.props.display_section === 'subscription_exists' || this.props.display_section === 'one_time_payment_complete') && this.props.proceed_action) {
                  this.props.proceed_action();
                  return;
                }
                if (this.props.open_single_payment_modal && selected_option === 'single_payment') {
                  this.props.open_single_payment_modal(price_id);
                  return;
                }
                if (this.props.open_subscription_payment_modal && (selected_option === 'monthly' || selected_option === 'six_months')) {
                  this.props.open_subscription_payment_modal(price_id);
                  return;
                }
              }}/>
    </View>
  }

  render_has_entered_payment_interface = () => {
    if (this.props.display_section !== 'one_time_payment_complete') {
      return null;
    }

    let is_mobile = Platform.OS === 'ios' || Platform.OS === 'android' ? true : false;

    return <View style={{ justifyContent: 'space-between', alignItems: 'center', height: 420 }}>

    <View style={{ height: 30 }}></View>
      { is_mobile ? <View style={{ alignItems: 'center' }}>
                      <LottieView loop={false} autoPlay={true} style={{ height: 200 }} source={require('../assets/animations/check-success.json')} />
                      <Text style={{ fontWeight: '500', fontSize: 22, position: 'absolute', marginTop: 155 }}>Payment Added!</Text>
                      <Text style={{ fontSize: 19, position: 'absolute', marginTop: 190, textAlign: 'center', color: 'grey' }}>A temporary authorization has been placed on your card. Your payment won’t be processed until the session has been completed.</Text>
                    </View>
                  : <View style={{ alignItems: 'center' }}>
                      <Icon name='check-circle' solid={true} color={Colors.GREEN} size={50} style={{ marginBottom: 15 }} />
                      <Text style={{ fontWeight: '500', fontSize: 22, marginBottom: 5 }}>Payment Added!</Text>
                      <Text style={{ fontSize: 19, textAlign: 'center', color: 'grey' }}>A temporary authorization has been placed on your card. Your payment won’t be processed until the session has been completed.</Text>
                    </View> }
      <View style={{ height: 150 }}></View>
    </View>
  }

  render_has_subscription_interface = () => {
    if (this.props.display_section !== 'subscription_exists') {
      return null;
    }

    let is_mobile = Platform.OS === 'ios' || Platform.OS === 'android' ? true : false;

    return <View style={{ height: 420 }}>
      <View style={{ position: 'absolute', justifyContent: is_mobile ? 'space-between' : 'center', alignItems: 'center', height: 420, width: '100%' }}>
        <View style={{ height: 30 }}></View>
        { is_mobile ? <View style={{ alignItems: 'center' }}>
                        <LottieView loop={false} autoPlay={true} style={{ height: 200 }} source={require('../assets/animations/check-success.json')} />
                        <Text style={{ fontWeight: '500', fontSize: 22, position: 'absolute', marginTop: 155 }}>You Are Subscribed!</Text>
                        <Text style={{ fontSize: 19, position: 'absolute', marginTop: 190, textAlign: 'center', color: 'grey' }}>You have access to FREE Chat and video consultations.</Text>
                      </View>
                    : <View style={{ alignItems: 'center' }}>
                        <Icon name='check-circle' solid={true} color={Colors.GREEN} size={50} style={{ marginBottom: 15 }} />
                        <Text style={{ fontWeight: '500', fontSize: 22, marginBottom: 5 }}>You Are Subscribed!</Text>
                        <Text style={{ fontSize: 19, textAlign: 'center', color: 'grey' }}>You have access to FREE Chat and video consultations.</Text>
                      </View> }
        { is_mobile ? <LottieView loop={false} ref={animation => { this.cat_eyes_animation = animation }} style={{ height: 150, alignSelf: 'flex-end' }} source={require('../assets/animations/cat-eyes.json')} /> : null }
      </View>
      { is_mobile ? <LottieView loop={false} ref={animation => { this.confetti_animation = animation }} style={{ width: '100%', alignSelf: 'flex-end' }} source={require('../assets/animations/confetti.json')} /> : null }
    </View>
  }

  render_loading_interface = () => {
    if (this.props.display_section !== 'loading_details') {
      return null;
    }

    let is_mobile = Platform.OS === 'ios' || Platform.OS === 'android' ? true : false;

    return <View style={{ justifyContent: 'space-between', alignItems: 'center', height: 420 }}>
      <View style={{ height: 130 }}></View>
      { is_mobile ? <View style={{ alignItems: 'center' }}>
                      <LottieView ref={animation => { this.loading_circle_animation = animation }} style={{ height: 100 }} source={require('../assets/animations/loading-circle.json')} />
                      <Text style={{ fontWeight: '500', fontSize: 16 }}>Retrieving Payment Details</Text>
                    </View>
                  : <View style={{ alignItems: 'center' }}>
                      <View style={{ height: 25, width: 25 }}>
                        <Progress.CircleSnail size={25} indeterminate={true} color={ Colors.PRIMARY } />
                      </View>
                      <View>
                        <Text style={{ fontWeight: '500', marginTop: 5 }}>Loading Payment Details...</Text>
                      </View>
                    </View> }
      <View style={{ height: 150 }}></View>
    </View>
  }

  render_processing_payment = () => {
    if (this.props.display_section !== 'processing_payment') {
      return null;
    }

    let is_mobile = Platform.OS === 'ios' || Platform.OS === 'android' ? true : false;

    return <View style={{ justifyContent: 'space-between', alignItems: 'center', height: 420 }}>
      <View style={{ height: 130 }}></View>
      { is_mobile ? <View style={{ alignItems: 'center' }}>
                      <LottieView ref={animation => { this.loading_circle_animation = animation }} style={{ height: 100 }} source={require('../assets/animations/loading-circle.json')} />
                      <Text style={{ fontWeight: '500', fontSize: 16 }}>Processing Payment</Text>
                    </View>
                    : <View style={{ alignItems: 'center' }}>
                        <View style={{ height: 25, width: 25 }}>
                          <Progress.CircleSnail size={25} indeterminate={true} color={ Colors.PRIMARY } />
                        </View>
                        <View>
                          <Text style={{ fontWeight: '500', marginTop: 5 }}>Processing Payment...</Text>
                        </View>
                      </View> }
      <View style={{ height: 150 }}></View>
    </View>
  }

  render() {
    return (
      <View style={styles.main_container}>
        { this.render_loading_interface ()  }
        { this.render_has_subscription_interface() }
        { this.render_has_entered_payment_interface() }
        { this.render_payment_options()     }
        { this.render_processing_payment()  }
        { this.render_continue_button()     }
      </View>
    );
  }

  render_error_message = () => {
    let error_message = this.props.error_message;
    if (error_message) {
      return <View style={{ marginBottom: 20 }}>
        <View style={{ backgroundColor: Colors.RED, padding: 15, borderRadius: 12 }}>
          <Text style={{ color: 'white', fontWeight: '500' }}>{ error_message }</Text>
        </View>
      </View>
    }
  }

  get_pricing_details = (option) => {
    let pricing_details     = {};
    let single_selected     = option === 'single_payment';
    let monthly_selected    = option === 'monthly';
    let six_months_selected = option === 'six_months';
    let price_data          = this.state.price_data || {};

    if (single_selected) {
      pricing_details['duration_string'] = 'Single Session';
      pricing_details['price_string']    = StringUtils.displayMoney(price_data.single_amount);
      pricing_details['feature_1_str']   = 'One-time session with a DodoVet pro.';
      pricing_details['feature_2_str']   = 'Live chat or video.';
      pricing_details['feature_3_str']   = 'You won’t be billed until the session is complete.';
      pricing_details['price_id']        = price_data.single_price_id;
    }

    if (monthly_selected) {
      pricing_details['duration_string'] = 'Monthly Unlimited';
      pricing_details['price_string']    = StringUtils.displayMoney(price_data.one_month_amount) + ' / Month';
      pricing_details['feature_1_str']   = 'Talk to a vet pro 24/7/365.';
      pricing_details['feature_2_str']   = 'Live chats and video sessions.';
      pricing_details['feature_3_str']   = 'Revisit the same pro.';
      pricing_details['price_id']        = price_data.one_month_price_id;
    }

    if (six_months_selected) {
      pricing_details['duration_string'] = '6 Month Access';
      pricing_details['price_string']    = StringUtils.displayMoney(price_data.six_month_amount) + ' / Month';
      pricing_details['feature_1_str']   = 'Get a free month of care!';
      pricing_details['feature_2_str']   = 'Exclusive content and resources.';
      // pricing_details['feature_3_str']   = 'Live Chat & Live Video included';
      pricing_details['price_id']        = price_data.six_month_price_id;
    }

    return pricing_details;
  }

  construct_price_data = (price_data) => {
    let price_data_obj = {};

    if (price_data) {
      price_data_obj['single_amount']      = price_data.payment_amount || config.payment_amount;
      price_data_obj['one_month_amount']   = price_data.subscription_amount_month ||  config.subscription_amount_month;
      price_data_obj['six_month_amount']   = price_data.subscription_amount_six_months || config.subscription_amount_six_months;
      price_data_obj['six_month_preview']  = price_data.subscription_amount_six_months_monthly_preview || config.subscription_amount_six_months_monthly_preview;
      price_data_obj['single_price_id']    = price_data.payment_price_id ||  config.payment_price_id;
      price_data_obj['one_month_price_id'] = price_data.subscription_amount_month_price_id ||  config.subscription_amount_month_price_id;
      price_data_obj['six_month_price_id'] = price_data.subscription_amount_six_months_price_id ||  config.subscription_amount_six_months_price_id;
    }

    if (!price_data) {
      price_data_obj['single_amount']      = config.payment_amount ||  '';
      price_data_obj['one_month_amount']   = config.subscription_amount_month ||  '';
      price_data_obj['six_month_amount']   = config.subscription_amount_six_months ||  '';
      price_data_obj['six_month_preview']  = config.subscription_amount_six_months_monthly_preview || '';
      price_data_obj['single_price_id']    = config.payment_price_id ||  '';
      price_data_obj['one_month_price_id'] = config.subscription_amount_month_price_id ||  '';
      price_data_obj['six_month_price_id'] = config.subscription_amount_six_months_price_id ||  '';
    }

    return price_data_obj;
  }

}

const styles = StyleSheet.create({
  main_container: {
    paddingRight: 20,
    paddingLeft: 20,
    paddingBottom: 20
  }
});

export default ConsultationStartPayment
